import { lazy, Suspense, FC } from 'react';

const HpRespAppBanner = lazy(
    () => import(/* webpackChunkName: "HpRespAppBanner" */ './HpRespAppBanner')
);

export const HpRespAppBannerLazy: FC = () => {
    return (
        <Suspense fallback="">
            <HpRespAppBanner />
        </Suspense>
    );
};
